import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const ArrowRightIcon = ({ ...props }: SvgIconProps) => {
  return (
    <SvgIcon
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M5 12H19M19 12L12 5M19 12L12 19'
        stroke='#14191F'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </SvgIcon>
  );
};

export default ArrowRightIcon;
